/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type TempoStatus = typeof TempoStatus[keyof typeof TempoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TempoStatus = {
  Unknown: 'Unknown',
  NoLinkSent: 'NoLinkSent',
  NotStarted: 'NotStarted',
  Completed: 'Completed',
} as const;
